import script from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&setup=true"

import "./ForgotPassword.vue?vue&type=style&index=0&id=6d9ecc48&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9ecc48"]])

export default __exports__